// extracted by mini-css-extract-plugin
module.exports = {"id":"EditCompanyUserModal_id__2Y2ZT","submitButton":"EditCompanyUserModal_submitButton__1mV1t"};